import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLanguage from "@/hooks/useLanguage";
import { localizePath } from "@/i18n/helpers";

const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/ibm-impact-logo.png`;

/*
  Brand lockup: "IBM Impact" logo image, an optional thin 1px vertical divider,
  and the program name. The program name stays in English across all locales.

  - Header (default): logo + divider + "IBM AI Action Plan for Nonprofits"
  - Footer:           logo + "AI Action Plan" (no divider)

  Links to the home page of the active locale.
*/
export default function Wordmark({
  variant = "light",
  name = "IBM AI Action Plan for Nonprofits",
  divider = true,
  onClick,
}) {
  const { t } = useTranslation();
  const { current } = useLanguage();
  const homePath = localizePath("home", current.code);

  return (
    <Link
      to={homePath}
      className={`wordmark wordmark--${variant}`}
      aria-label={t("common.wordmarkAria")}
      onClick={onClick}
      data-testid="wordmark-home-link"
    >
      <img src={LOGO_SRC} alt="" className="wordmark__logo" />
      {divider && <span className="wordmark__divider" aria-hidden="true" />}
      <span className="wordmark__name">{name}</span>
    </Link>
  );
}
